import { requests } from "../../../services/external/APIs";
import {
  OvertimeWorkedAndScheduledPerPeriodModel,
  OvertimeWorkedAndScheduledPerPeriodRequest,
} from "../models/OvertimeSchedule";
import {
  CreateWorkshiftSchedulingRequest,
  DeleteWorkshiftsSchedulingRequest,
  SchedulingResponseModel,
} from "../models/WorkingSchedulingRequests";

const API_URL = "/dublin/api/";

export const getOvertimeSchedule = async (
  model: OvertimeWorkedAndScheduledPerPeriodRequest,
): Promise<OvertimeWorkedAndScheduledPerPeriodModel[]> =>
  requests.post(
    `${API_URL}v1/liquidate/get-overtime-worked-and-scheduled-per-period`,
    model,
  );

export const createWorkshiftSchedulings = async (
  body: CreateWorkshiftSchedulingRequest,
): Promise<SchedulingResponseModel> =>
  requests.post(
    "/jerusalem/api/v2.0.0/workshift-schedulings/create-schedulings",
    body,
  );

export const deleteWorkshiftSchedulings = async (
  body: DeleteWorkshiftsSchedulingRequest,
): Promise<void> =>
  requests.deleteWithBody(
    "/jerusalem/api/v2.0.0/workshift-schedulings/delete-workshift-schedulings",
    body,
  );

export const downloadOverTimeReport = async (
  body: Omit<OvertimeWorkedAndScheduledPerPeriodRequest, "preliquidateTypeId">,
): Promise<void> =>
  requests.postWithParameters(
    "/dublin/api/v2/reports/get-overtime-worked-and-scheduled-per-period",
    body,
    { responseType: "blob" },
  );

export const downloadConsolidateByHourTypeOverTimeReport = async (
  body: Omit<OvertimeWorkedAndScheduledPerPeriodRequest, "preliquidateTypeId">,
): Promise<void> =>
  requests.postWithParameters(
    "/dublin/api/v2/reports/get-consolidate-overtime-worked-and-scheduled-per-period",
    body,
    { responseType: "blob" },
  );
